<script>
  import { fly } from 'svelte/transition';
  import { createEventDispatcher } from 'svelte';
  import RightPane from '../Panes/RightPane.svelte';
  import { getEgresoDets } from '../../models/egresoDetModel';
  import { getEgresoFiles } from '../../models/egresoFilesModel';
  import { getEgresoEscoltas, getEgresoCorredores, getEgresoPickers } from '../../models/egresoCabModel';
  
  const dispatch = createEventDispatcher();
  
  export let title;
  export let status;
  export let items;

  let selectedItem = null;

  async function handleClick(item) {
    // Si `item` es un objeto (no un array), obtener directamente los detalles de egresoDet
    const egresoDets = await getEgresoDets(item.id, 1, 100);  // Ajusta la paginación de egresoDet si es necesario
    const egresoFile = await getEgresoFiles(item.id, 1, 100);  // Ajusta la paginación de egresoFiles si es necesario
    const egresoEscolta = await getEgresoEscoltas(item.id, 1, 100);  // Ajusta la paginación de egresoFiles si es necesario
    const egresoCorredor = await getEgresoCorredores(item.id, 1, 100);
    const egresoPicker = await getEgresoPickers(item.id, 1, 100);
    // Actualizar selectedItem con el egresoCab y sus detalles
    selectedItem = {
      ...item,  // Mantener los datos del egresoCab
      egresoDet: egresoDets.items,  // Agregar los detalles de egresoDet
      egresoFiles: egresoFile.items,  // Agregar los detalles de egresoFiles
      escoltas: egresoEscolta.items,  // Agregar los detalles de egresoEscolta
      corredores: egresoCorredor.items, // Agregar los detalles de egresoCorredor
      pickers: egresoPicker.items, // Agregar los detalles de egresoPicker
    };

    console.log("selectedItem",selectedItem)
  }

  function closePane() {
    selectedItem = null;
  }

  function formatDate(dateStr) {
    // Create date object from the input string (which is already in Guatemala time)
    const date = new Date(dateStr);
    if (isNaN(date)) return '';
    
    // Format date components - no timezone conversion needed since input is already in Guatemala time
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    // Get hours in 12-hour format
    let hours = date.getHours();
    const ampm = hours >= 12 ? 'p. m.' : 'a. m.';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    return `${day}/${month}/${year}, ${String(hours).padStart(2, '0')}:${minutes}:${seconds} ${ampm}`;
  }

  const statusColors = {
    NOT_READY: 'bg-red-200 border-red-300 text-red-700',
    PACKING: 'bg-yellow-500 border-yellow-600 text-yellow-900',
    PARTIALLY_READY: 'bg-orange-200 border-orange-300 text-orange-700',
    READY: 'bg-teal-200 border-teal-300 text-teal-700',
    ON_ROUTE: 'bg-lightBlue-200 border-lightBlue-300 text-lightBlue-700',
    DELIVERED: 'bg-emerald-200 border-emerald-300 text-emerald-700',
    RETURNED: 'bg-red-200 border-red-300 text-red-700',
    DEFAULT: 'bg-gray-100 border-gray-300 text-gray-700',
  };

  function getStatusColor() {
    return statusColors[status] || statusColors.DEFAULT;
  }

  function handleLocationUpdate(event) {
      console.log("Event payload in CardStatus:", event.detail);
      const { id, geo_target_ref, geo_delivery_ref } = event.detail;

      // Update the local state
      items = items.map(item => {
          if (item.id === id) {
            return {
                ...item,
                ...(geo_target_ref && { geo_target_ref }),
                ...(geo_delivery_ref && { geo_delivery_ref })
            };
          }
          return item;
      });

      // Optionally, dispatch the event to the parent component
      dispatch('updateLocation', event.detail);
  }
  

  function handleDeliveryUpdate(event) {
    console.log("Event payload in CardStatus (Delivery Update):", event.detail);
    const { id, delivery_method, delivery_ref, delivery, transporte, transporte_ref, target_ref, vehiculo  } = event.detail;

    // Asegurar que se actualizan las claves correctas
    items = items.map(item => {
        if (item.id === id) {
          return {
              ...item,
              ...(delivery_method && { delivery_method }),
              ...(delivery_ref && { delivery_ref }),
              ...(delivery && { delivery }),
              ...(transporte && { transporte }),
              ...(transporte_ref && { transporte_ref }),
              ...(target_ref && { target_ref }),
              ...(vehiculo && { vehiculo })
          };
        }
        return item;
    });

    console.log("Updated items in CardStatus:", items);

    // Enviar el evento al componente padre con la estructura correcta
    dispatch('updateDelivery', event.detail);
  }

  function handleEgresoEscoltaUpdate(event) {
    console.log("Event payload in CardStatus (Escoltas Update):", event.detail);
    const { egresoId, escoltas } = event.detail;

    // Ensure the correct keys are updated in the items array
    items = items.map(item => {
      if (item.id === egresoId) {
        return {
          ...item,
          escoltas: escoltas // Update escoltas for the matching item
        };
      }
      return item;
    });

    console.log("Updated items in CardStatus (Escoltas):", items);

    // Dispatch the escoltas update to the parent component or store
    dispatch('updateEgresoEscolta', {
      egresoId: egresoId,
      escoltas: escoltas
    });
  }
</script>

<div
  class={`relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded border ${getStatusColor()}`}
  style="height: 480px;" 
>
  <div class={`rounded-t mb-0 px-4 py-3 border-0 ${getStatusColor()}`}>
    <div class="flex flex-wrap items-center">
      <div class="relative w-full px-4 max-w-full flex-grow flex-1">
        <h3 class="font-semibold text-base">{title} ({items.length})</h3>
      </div>
    </div>
  </div>

  <div class="block w-full overflow-y-auto p-4" style="height: calc(100% - 116px);">
    {#if items.length > 0}
      <ul class="list-none">
        {#each items as item (item.id)}
          <li
            transition:fly={{ y: 20, duration: 600 }}
            class=" py-2 hover:bg-blueGray-100 hover:shadow-md transition-all duration-300 cursor-pointer"
            style="height: 60px;"
            on:click={() => handleClick(item)}
          >
            <div class="flex justify-between">
              <span class="text-blueGray-700">{item.nombre}</span>
            </div>
            <div class="flex justify-between">
              <div class="text-blueGray-400 text-sm">{formatDate(item.created)}</div>
              <span class="text-blueGray-500 text-sm">{item.delivery_method}</span>
              <span class="text-blueGray-500 text-sm">{item.numero}</span>
            </div>
          </li>
        {/each}
      </ul>

      <RightPane 
        {selectedItem}
        {closePane}
        {status}
        on:updateLocation={handleLocationUpdate}
        on:updateDelivery={handleDeliveryUpdate}
        on:updateEgresoEscolta={handleEgresoEscoltaUpdate}
      />
    {:else}
      <p class="text-blueGray-400 text-sm">No hay items en este estado.</p>
    {/if}
  </div>

  <div class={`rounded-b px-4 py-3 border-t mt-auto ${getStatusColor()}`}>
    <div class="text-blueGray-500 text-sm">
      Total: {items.length} items
    </div>
  </div>
</div>